import '@mrhenry/wp--bugsnag-config';
import '@mrhenry/wp--autoplay-in-view';

import './modules/mr-booking-inputs';
import './modules/mr-carousel-formatted';
import './modules/mr-cta-panel-overlay';
import './modules/mr-hover-animation';
import './modules/mr-navigation-overlay';
import './modules/mr-set-attribute-when-intersecting';
import './modules/mr-video';
import './modules/mr-video-overlay';

import { MrAccordion,
	MrCarousel,
	MrDisplayValue,
	MrInputSink,
	MrMenu,
	MrPlayPauseToggle,
	MrTabs,
	manageNonConcurrentPlayback } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-accordion', MrAccordion );
customElements.define( 'mr-carousel', MrCarousel );
customElements.define( 'mr-display-value', MrDisplayValue );
customElements.define( 'mr-input-sink', MrInputSink );
customElements.define( 'mr-menu', MrMenu );
customElements.define( 'mr-play-pause-toggle', MrPlayPauseToggle );
customElements.define( 'mr-tabs', MrTabs );
manageNonConcurrentPlayback();
